// @react/hooks/useAuth.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { authStore } from '@core/stores';
import type { SignInRequest } from '@core/types/authn/SignInRequest';
import type { SignUpRequest } from '@core/types/authn/SignUpRequest';
import type { User } from '@core/types/authn/User';

/**
 * React hook for authentication.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useAuth } from '@react/hooks';
 *
 * const LoginPage = observer(() => {
 *   const auth = useAuth();
 *
 *   if (auth.isAuthenticated) {
 *     return <Navigate to="/dashboard" />;
 *   }
 *
 *   return <LoginForm onSubmit={auth.login} isLoading={auth.isLoading} />;
 * });
 * ```
 */
export function useAuth() {
  return {
    // State
    user: authStore.user as User | null,
    userId: authStore.userId,
    activeProfileId: authStore.activeProfileId,
    isAuthenticated: authStore.isAuthenticated,
    isLoading: authStore.isLoading,
    error: authStore.error,
    accessToken: authStore.accessToken,

    // Actions
    login: (credentials: SignInRequest) => authStore.login(credentials),
    register: (data: SignUpRequest) => authStore.register(data),
    logout: () => authStore.logout(),
    clearError: () => authStore.clearError(),
  };
}

// Re-export types for convenience
export type { SignInRequest };
export type { SignUpRequest };
export type { User };
